<template>
  <div class="CARD">
    <div v-if="pause" class="d-flex w-100">
      <div class="TIME">
        <template>
          <span class="c-gray70">
            {{ startDate }}
          </span>
          <span class="c-gray70">
            {{ endDate }}
          </span>
        </template>
      </div>
      <div class="flex-1-1">
        <div class="d-flex jc-between">
          <a @click.prevent="edit" class="BODY">
            <div class="fd-column ov-hidden p-l-2 text-bold">
              <transition name="FADE" mode="out-in">
                <div >
                  <div >{{ occupationName }}</div>
                </div>
              </transition>
            </div>
          </a>
          <div>
            <vk-listbox
                display-text="..."
                class="OPTIONS"
                menuClass="MENU"
                value=""
                @input="handleSelection">
              <vk-listbox-option
                  v-for="(option, index) in options"
                  class="OPTION bd-x-gray50 text-bold"
                  :class="{
                    'bd-t-gray50':index === 0,
                    'c-depot':index ===options.length -1
                  } "
                  :key="index + option"
                  :value="option">
                {{ option }}
              </vk-listbox-option>
            </vk-listbox>
          </div>
        </div>
        <div class="text-right">
          <div class="m-r-3 c-gray60 text-md">
            Set On: {{ formatDate(pause.createdDTM) }}
          </div>
          <div class="m-r-3 c-gray60 text-md">
            Last Modified: {{ formatDate(pause.modifiedDTM) }}
          </div>
        </div>
      </div>
    </div>
    <paused-leads-list-item-placeholder v-else />
  </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { format, startOfDay } from 'date-fns';
import PausedLeadsListItemPlaceholder from './PausedLeadsListItemPlaceholder';

export default {
  name: 'paused-leads-list-item',
  components: {
    PausedLeadsListItemPlaceholder,
  },
  props: {
    id: [String, Number],
    pause: Object,
  },
  data () {
    return {
      options: ['Edit', 'Delete'],
    };
  },
  computed: {
    ...mapGetters('account/pro', [
      'serviceProviderCatalogOccupations',
    ]),
    occupationName () {
      if (this.pause.serviceProviderOccupationId) {
        return this.serviceProviderCatalogOccupations[this.pause.serviceProviderOccupationId]
          .occupation.display_name;
      }
      return `All Occupations (${Object.keys(this.serviceProviderCatalogOccupations).length})`;
    },
    startDate () {
      return format(startOfDay(new Date(`${this.pause.startDate}T00:00:00`)), 'MMM dd, yyyy');
    },
    endDate () {
      return `- ${format(startOfDay(new Date(`${this.pause.endDate}T00:00:00`)), 'MMM dd, yyyy')}`;
    },
  },
  methods: {
    handleSelection (selectedOption) {
      switch (selectedOption) {
        case 'Edit':
          this.$events.$emit(this.$events.PAUSE_DOTS_DELETE_CLICK);
          this.edit();
          break;
        default:
          this.$events.$emit(this.$events.PAUSE_DOTS_EDIT_CLICK);
          this.deletePause();
      }
    },
    edit () {
      this.$emit('onEdit', this.pause);
    },
    deletePause () {
      this.$emit('onDelete', this.pause);
    },
    formatDate (date) {
      return format(new Date(date), 'MMM d, p');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";
  @import "~@/views/Dashboard/tools";

  .BODY {
    @include hover(text-decoration, none, none);
    @include desktop-hover(background-color, transparent, $color-gray20);
    @include pseudo(visited, color, $color-gray80, $color-gray80);
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    background-color: white;
    will-change: background-color;
    transition: background-color $transition-half-duration;
    cursor: pointer;
  }
  .CARD {
    margin: 2 *$unit 2 *$unit 0px 2 *$unit;
    padding-bottom: $unit;
    border-bottom: 1px solid $color-gray30;
  }

  .EDIT {
    font-weight: 400;
    color : #3E7697
  }

  .BUTTON{
    min-height: $appointment-list-item-min-height;
  }

  .TIME {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    width: 14.25 * $unit;
    padding-right: 2*$unit;
    border-right: 6px solid $color-gray50;
    text-align: left;
    white-space: nowrap;
  }
  .OPTIONS {
    @include text-medium;

    /deep/ .input {
      width: 50px;
      padding: 0;
      border: none;
      font-weight: 700;
      font-size: 34px;
      color: $color-depot;
      font-family: serif;
      align-items: start;
      margin-left: $unit;

      .VK-LISTBOX-TEXT {
        padding-right: $unit;
      }

      .CHEVRON {
        color: transparent;
      }
    }

    /deep/ .MENU {
      top: 3*$unit;
      right: 10px;
      height: auto;
      width: 100px;
      padding: $unit 0;
      border: none;
      overflow: auto;
      background-color: transparent;

    }
  }
  .OPTION {
    background-color: white;
    border-bottom: solid 1px $color-gray50;
    @include hover(transform, none, none);
    transition: none;

  }
</style>
